// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2n-1";
export var movingGradient = "_2n-4";
export var movingGradientBlock = "_2n-2";
export var skeleton = "_2n-0";
export var skeletonText = "_2n-3";